import * as Styled from './Diamond.style'

const Diamond = () => <Styled.Div />

export default Diamond